import { FaBug, FaSun } from "react-icons/fa";
import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { useResponsiveClass } from '../utils/responsiveUtilities';
import { useAppDispatch, useAppSelector } from "../hooks";
import { getLayout, setUser } from "../features/Users/UsersSlice";
import { checkTimestampStatus, getByPath, getConfigByPath, validity } from "../features/Sensors/SensorUtils";
import IMeasurement from "../interfaces/measurement.interface";
import OpenButton from "./popup_components/OpenButton";
import BugReport from "./Forms/BugReport";
import {c_day, c_month, c_time, c_year} from "../config/uiconfig"
import { useLocalStorageState } from "hooks/useLocalStorageState";

export default function InfoBar() {
    useResponsiveClass('page-wrapper', 'page-mob', 'page');
    const darkModeClick = () => {
        const html = document.documentElement;
        if(dark===true){
            setDark(false);
        }else{
            setDark(true);
        }
        html.classList.toggle("dark");
        
    }

    const { instance, accounts } = useMsal();
    const dispatch = useAppDispatch()
    const account = useAppSelector(state => state.Users.account);
    const cruise = useAppSelector(state => state.Projects.current_project)
    const phase = useAppSelector(state => state.Phases.current_phase)
    const connection = useAppSelector(state => state.Connection.connection)
    const measurements = useAppSelector(state => state.Measurements.measurements);
    const [dark, setDark] = useLocalStorageState<boolean>(
        "darkness",
        false
        );
    useEffect(() => {
        dispatch(setUser(accounts.at(0)));
    }, [])

    useEffect(() => {
  const html = document.documentElement;

        if (dark) {
            html.classList.add("dark");
        } else {
            html.classList.remove("dark");
        }
        }, [dark]);

    useEffect(() => {
        dispatch(getLayout(account?.username));
    }, [account])
    const toggleNavbar = () => {
        const navbar = document.getElementById('navbar');
        const widthButton = document.getElementById('close-navbar');
        if (navbar && widthButton) {
            navbar.style.width = navbar.style.width === '0%' ? '20%' : '0%';
            widthButton.innerHTML = navbar.style.width === '0%' ? '&gt;&gt;&gt;' : '&lt;&lt;&lt;';
        }
    }
    const createTimeStamp = (measurements: IMeasurement[]): string => {
        const year = getByPath(c_year, measurements)?.value;
        const month = getByPath(c_month, measurements)?.value;
        const day = getByPath(c_day, measurements)?.value;
        const time = getByPath(c_time, measurements)?.value;

        if (!year || !month || !day || !time) return "";

        // Convert to numbers
        const y = Number(year); // two-digit year
        const m = Number(month);
        const d = Number(day);
        const t = Number(time); // hhmmss

        // Pad day/month/time properly
        const mStr = String(m).padStart(2, "0");
        const dStr = String(d).padStart(2, "0");
        const tStr = String(t).padStart(6, "0"); // ensures hhmmss

        const hh = tStr.substring(0, 2);
        const mm = tStr.substring(2, 4);
        const ss = tStr.substring(4, 6);

        
        return `20${y}-${mStr}-${dStr} ${hh}:${mm}:${ss}`;
    };

    const validity: validity = checkTimestampStatus(getByPath(c_time, measurements)?.timestamp, 5000);
    return (
        <>
            <div className="info-bar flex justify-between sticky top-0 dark:bg-nred dark:text-black">
                <div className="flex justify-between gap-1 w-fit items-center">
                    <div id='close-navbar' className="left flex items-center gap-2 mr-2" onClick={toggleNavbar}>
                        &lt;&lt;&lt;
                    </div>
                    <FaSun onClick={darkModeClick}></FaSun>
                    <OpenButton text={<FaBug />} newContent={<BugReport />} styleClasses="bug-button" />
                </div>
                <div className="right">
                    <div className="flex">
                        <p className="status_bar_element">{connection.status}</p>|
                        <p className="status_bar_element">{account?.username}</p>|
                        {cruise?.name !== undefined ?
                            <>
                                <p className="status_bar_element">{process.env.REACT_APP_EXPO_CODE}{cruise?.mfp_id + '|'}</p>
                                <p className="status_bar_element">{phase?.type + ' ' + phase?.index + '|'} </p>
                                <p className="status_bar_element">{cruise?.departure_port + ' >> ' + cruise?.arrival_port + '|'}</p>

                            </>
                            : <></>}
                        <p className={"status_bar_element " + validity.color}>{createTimeStamp(measurements)} UTC</p>
                    </div>
                </div>
            </div>
        </>
    )
}